import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import {
  LeftSide,
  ModalBody,
  ModalContent,
  ModalHeader,
  ProfessionInfoModalStyles,

  TextContainer,
  TitleBox,
} from './ProfessionInfoModal.styles';
import infoIcon from '../../../../assets/redesign_icons/info-icon.svg';

function MalattiaNobisModal({
  setShowModal,

}) {
  const closeModal = () => {
    setShowModal(false);
  };

  return (
    <ProfessionInfoModalStyles>
      <ModalBody>
        <ModalHeader>
          <LeftSide>
            <FontAwesomeIcon
              fontSize={34}
              icon={faTimes}
              cursor="pointer"
              onClick={() => closeModal()}
            />
            <TextContainer>
              <TitleBox>
                <img src={infoIcon} alt="" />
                <h3>Informazione</h3>
              </TitleBox>
              <p>Qui puoi controllare le informazioni su questa offerta.</p>
            </TextContainer>
          </LeftSide>

        </ModalHeader>
        <ModalContent>
          <p className="fw-bold">Rimborso spese di cura</p>
          <p className="mt-3">La Società rimborsa all'Assicurato le spese sostenute per infortunio o malattia fino alla concorrenza del massimale indicato in polizza ed entro i limiti temporali prefissati, ad esempio per:</p>
          <p className="mt-3">- accertamenti diagnostici</p>
          <p>- rette di degenza</p>
          <p>- transporto da e per l'istituto di cura, esami, medicinali</p>
          <p>- trapianto di organi, o parti di essi, per malattia o infortunio compreso il prelievo sul donatore</p>
          <p className="mt-3">La garanzia è operante in caso di:</p>
          <p className="mt-3">- ricovero in istituto di cura pubblico o privato</p>
          <p>- intervento chirurgico anche senza ricovero, in istituto di cura pubblico o privato o ambulatorio</p>
          <p>- parto o aborto terapeutico comportante il ricovero</p>
          <p className="mt-3">Nel caso in cui l'Assicurato si avvalga del S.S.N., le prestazioni sono valide per le spese sostenute in propio o sono sostituite da una indennità nel caso in cui il ricovero sia a totale carico del Servizio Pubblico</p>

          <p className="fw-bold mt-3">Diaria da ricovero</p>

          <p className="mt-3">- in caso di ricovero in istituto pubblico o privato, per malattia o infortunio, la Società rimborsa l'indennità giornaliera assicurata per ogni giorno di degenza con il limite di 300 giorni per evento e per anno assicurativo</p>
          <p>- garanzia valida anche per Day Hospital non inferiore a 3 giorni consecutivi</p>

          <p className="fw-bold mt-3">Diaria da convalescenza o da gessatura</p>

          <p className="mt-3 ">- in caso di ricovero in istituto pubblico o privato, non derivante da infortunio comportante gassatura, verrà corrisposta un'indennità giornaliera di convalescenza per una durata pari a quella del ricovero, per un massimo di 60 giorni;</p>
          <p>- in caso di gessatura, conseguente ad infortunio con o senza ricovero, verrà corrisposta la suddetta indennità giornaliera fino alla rimozione del gesso, per un periodo massimo di 45 giorni per arti superiori e di 90 giorni per arti inferiori, vertebre e bacino.</p>

          <p className="fw-bold mt-3">Invalidità Permanente da malattia</p>

          <p className="mt-3 ">Liquidazione di un importo in base alla percentuali riportate nelle condizioni di assicurazione, per IP maggiore o uguale al 25%</p>

        </ModalContent>
      </ModalBody>
    </ProfessionInfoModalStyles>
  );
}

export default MalattiaNobisModal;
